/** @format */

export const wabaGetStatus = (data) => ({ type: "WABA_GET", data });

export const wabaSetStatus = (data) => ({
  type: "WABA_SET",
  data,
});

export const resetWABA = (data) => ({ type: "WABA_RESET", data });
